import { useQuery, useQueryClient } from "@tanstack/react-query";
import { env } from "config/env";
import React from "react";
import { useNavigate } from "react-router";
import Session from "supertokens-web-js/recipe/session";
import { AUTH_QUERY_KEY } from "./constants";
import { getReturnTo } from "./helpers";

export function useSession() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const hasSession = useQuery({
    queryKey: AUTH_QUERY_KEY,
    queryFn: () => env.IS_AUTOMATION || Session.doesSessionExist(),
    suspense: true,
    staleTime: Number.POSITIVE_INFINITY,
    retry: 2,
  });

  return {
    hasSession: hasSession.data,
    onLogin: React.useCallback(async () => {
      await hasSession.refetch();
      await navigate(getReturnTo());
    }, [navigate, hasSession.refetch]),
    signOut: React.useCallback(async () => {
      await Session.signOut();
      await hasSession.refetch();
      await queryClient.resetQueries();
    }, [hasSession.refetch, queryClient]),
  };
}
